import React, { ReactNode } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useAuth } from "../context/AuthContext";

interface LayoutProps {
    children: ReactNode;
    routeBack?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, routeBack}) => {
    const { user } = useAuth();

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <Header user={{ "name": user?.name || "" }} routeBack={routeBack}/>
            <main style={{ flex: 1, padding: "20px", backgroundColor: "#F7F7F7" }}>
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
